import React from 'react';

import { Typography } from '@hpstellar/core';

import PartnerLogosEnhanced from '../../shared/components/partner-logos-enhanced';
import withPageComponents from '../../page/components/with-page-components';
import { buildFilterFromUrl, filterLogos } from '../util';

import './vwa-header.less';

function VWAHeader({ partnerLogos, seo, location }) {
    const title = seo?.h1Tag || '';
    const [prePath, locationRest] = location.pathname.split('vwa/');
    const [locationSlug, path] = locationRest.split('/');
    const filters = buildFilterFromUrl(path || '');

    const { logos } = partnerLogos || {};

    const filteredLogos = filterLogos(filters, logos);

    return (
        <div className="vwa-header">
            <Typography className="vwa-header-title" tag="h1" variant="h2">
                {title}
            </Typography>
            <PartnerLogosEnhanced logos={filteredLogos} />
        </div>
    );
}

export default withPageComponents(VWAHeader, {
    components: ['partnerLogos'],
    seo: true,
});
